import { useState } from "react";
import "./index.scss";

const NavLanguage = ({ market, currentLanguage, onLanguageChange }) => {
  const [showMarketFlag, setShowMarketFlag] = useState(false);

  const changeLanguage = (language) => {
    onLanguageChange(language);
  };

  const flagSrc = showMarketFlag 
    ? `https://mwa.tui.com/shared/mwa/assets/v2/flags/${market}.svg` 
    : "https://mwa.tui.com/shared/mwa/assets/v2/flags/gb.svg";

  const flagAlt = showMarketFlag ? `${market} flag` : "uk flag";

  return (
    <span className="nav-language">
      <p className="flag-icon">
        <a
          href="#"
          title={flagAlt}
          onClick={(e) => {
            e.preventDefault();
            if (showMarketFlag) {
              changeLanguage(market);
            } else {
              changeLanguage('gb');
            }
            setShowMarketFlag(!showMarketFlag);
          }}
        >
          <img
            src={flagSrc}
            alt={flagAlt}
            className="flag-img"
          />
        </a>
      </p>
    </span>
  );
};

export default NavLanguage;
